import { ChangeDetectorRef, Component, ElementRef, forwardRef } from '@angular/core';
import { UserAccess } from '@core/authorization/user-access';
import { DialogBase, DialogButton, Dialogs, M27Dialog } from '@m27/common';
import { IStewardedRegCompReportCriteria } from '@reporting/interfaces/stewarded-regcomp-report';
import { ReportService } from '@reporting/services';
import { IGeographyDropDown } from '@shared/interfaces';
import { ICheckBox } from '@shared/interfaces/form-controls';
import { Globals } from '@shared/models';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'reporting-dialog-stewarded-regcomp-report-criteria',
    templateUrl: './dialog-stewarded-regcomp-report-criteria.component.html',
    styleUrls: ['./dialog-stewarded-regcomp-report-criteria.component.scss'],
    providers: [{ provide: DialogBase, useExisting: forwardRef(() => StewardedRegCompReportCriteriaDialogComponent) }]
})
export class StewardedRegCompReportCriteriaDialogComponent extends DialogBase implements M27Dialog {
    public userAccess: UserAccess = Globals.UAC;

    public availableCrops: ICheckBox[] = [
        { Name: 'Corn', Value: 'CORN', IsChecked: false, IsDisabled: false },
        { Name: 'Soybeans', Value: 'SOY', IsChecked: false, IsDisabled: false },
        { Name: 'Sorghum', Value: 'SORG', IsChecked: false, IsDisabled: false },
        { Name: 'Canola', Value: 'CANO', IsChecked: false, IsDisabled: false },
        { Name: 'Wheat', Value: 'WHE', IsChecked: false, IsDisabled: false },
        { Name: 'Cotton', Value: 'COTN', IsChecked: false, IsDisabled: false },
        { Name: 'Alfalfa', Value: 'ALF', IsChecked: false, IsDisabled: false }
    ];
    public reportItems = [
        { Name: 'Stewared RegComp Report', Value: 1, IsChecked: true, IsDisabled: false }
    ];
    private numberOfYears = 10;
    public availableYears: ICheckBox[] = [];
    public selectedCountryList: IGeographyDropDown[] =  [
        { id: 539230, itemName: 'US w/ PR' }
    ];
    public selectedCountyList: IGeographyDropDown[] = [];
    public selectedStateList: IGeographyDropDown[] = [];
    public selectedReport: number;
    public locationName = '';
    public reportIdJustCreated = 0;
    public showReportJustCreatedBadge = false;
    private showNewReportBadgeSubscription: Subscription;

    // this is only calls once for entire web session
    constructor(private reportService: ReportService, cd: ChangeDetectorRef, elRef: ElementRef) {
        super(cd, elRef);

        const startYear: number = (new Date()).getFullYear();

        for (let x = 0; x < this.numberOfYears; x++) {
            this.availableYears.push({ Name: `${startYear - x}`, Value: startYear - x, IsChecked: false, IsDisabled: false });
        }
    }

    // this is only calls once for entire web session
    public onDialogReady(): void {
    }

    onCheckboxChange(event: any): void {
        setTimeout(() => {
            this.reportItems.forEach(p => p.IsChecked = false);
            this.reportItems.filter(p => 'chkSR' + p.Name === event.target.id).forEach(p => p.IsChecked = true);
        });
    }

    private setupButtons(): void {
        if (this.isBackButtonEnabled()) {
            this.leftButtons.push({
                IsCancel: true,
                Text: 'Back',
                Action: (dialogBase: DialogBase) => {
                    this.close();
                }
            } as DialogButton);
        }

        this.rightButtons.push({
            IsCancel: false,
            Text: 'Run Report (Stay)',
            IsDisabled: () => {
                return !this.validateCanRunReport();
            },
            Action: (dialogBase: DialogBase) => {
                this.runReport(true);
            }
        } as DialogButton);

        this.rightButtons.push({
            IsCancel: false,
            Text: 'Run Report (Go)',
            IsDisabled: () => {
                return !this.validateCanRunReport();
            },
            Action: (dialogBase: DialogBase) => {
                this.runReport(false);
            }
        } as DialogButton);
    }

    private runReport(stay: boolean): void {
            this.reportService.RunStewardedRegCompReport({
                Crops: this.availableCrops.filter(item => item.IsChecked).map(item => item.Value),
                Years: this.availableYears.filter(item => item.IsChecked).map(item => item.Value),
                CountryIds: this.selectedCountryList.map(row => row.id),
                CountryNames: this.selectedCountryList.map(row => row.itemName),
                CountyIds: this.selectedCountyList.map(row => row.id),
                StateIds: this.selectedStateList.map(row => row.id),
                LocationName: this.locationName
            } as IStewardedRegCompReportCriteria).subscribe((reportId: number) => {
                if (!stay) {
                    Dialogs.navigate(`/reporting/reports/stewardedregcomp/${reportId}`);
                    return;
                }

                this.reportIdJustCreated = reportId;
                this.showReportJustCreatedBadge = true;

                if (this.showNewReportBadgeSubscription !== undefined) {
                    this.showNewReportBadgeSubscription.unsubscribe();
                }

                this.showNewReportBadgeSubscription = timer(3500).subscribe(() => {
                    this.showReportJustCreatedBadge = false;
                });
            });
    }

    public validateCanRunReport(): boolean {
        const hasCrop = this.availableCrops.filter(item => item.IsChecked).length > 0;
        const hasYear = this.availableYears.filter(item => item.IsChecked).length > 0;
        const hasCountry = this.selectedCountryList.length > 0;
        const hasReport = this.reportItems.filter(item => item.IsChecked).length > 0;

        return hasCrop && hasYear && hasCountry && hasReport;
    }

    public CheckBoxClicked(e): void {
        if (this.availableCrops != null) {
            this.availableCrops.forEach(p => p.IsChecked = true);
        }
    }

    public open(closeAll = false) {
        this.onOpen.emit(false);
        this.modal.open();

        this.setupButtons();
    }

    onDestroy() {
        this.clearButtons();
    }

    canCancel(): boolean {
        return true;
    }
}
